<script setup lang="ts">
import axios from 'axios'

import Mockup from '@/components/Mockup.vue'
import MockupTabletRewards from '@/components/MockupTabletRewards.vue'
import WebAppPreview from './WebAppPreview.vue'

import type { LoyaltyReward } from '@/types/types'

const { t } = useI18n()
defineProps<{
  rewards: LoyaltyReward[]
  preview?: boolean
}>()

const emit = defineEmits<{
  (e: 'endLoading'): void
}>()

const notification = useNotification()
const selectedDevice = ref<'tablet' | 'webapp'>('webapp')
const { user } = useLocalStorage()
let rewardTexts = reactive(null)
let rewardColors = reactive(null)
const isLoaded = ref(false)

const fetchMerchant = async () => {
  const merchantId = user.value.merchant.id
  try {
    const { data } = await axios.get(`merchants/${merchantId}`)
    rewardTexts = data.data.texts
    rewardColors = data.data.color
    emit('endLoading')
    isLoaded.value = true
  } catch (error) {
    if (error.response && error.response.status === 404) {
      notification.create('error', {
        text: 'Erreur lors du chargement des préférences de personnalisation',
        persist: true,
        timeout: 4000
      })
    }
  }
}

fetchMerchant()
</script>
<template>
  <div
    v-if="isLoaded"
    class="flex w-full flex-col items-center justify-center px-6"
    :class="{ 'pb-32': selectedDevice === 'webapp' }"
  >
    <Tabs v-model="selectedDevice" class="my-6">
      <TabsList>
        <TabsTrigger value="tablet">
          <BaseIcon name="HeroDevicePhoneMobileIconOutline" class="h-4 w-4 -rotate-90 text-foreground-secondary" />
          {{ t('pages.loyaltyPage.mockup.devices.tablet.name') }}
        </TabsTrigger>
        <TabsTrigger value="webapp">
          <BaseIcon name="HeroDevicePhoneMobileIconOutline" class="h-4 w-4 text-foreground-secondary" />
          {{ t('pages.loyaltyPage.mockup.devices.webapp.name') }}
        </TabsTrigger>
      </TabsList>
    </Tabs>
    <MockupTabletRewards
      v-if="selectedDevice === 'tablet'"
      :rewards="rewards"
      :reward-colors="rewardColors"
      :reward-texts="rewardTexts"
    />
    <Mockup v-if="selectedDevice === 'webapp'" type="mobile">
      <WebAppPreview :rewards="rewards" :color="rewardColors.background" />
    </Mockup>
  </div>
  <div v-else>
    <AppSkeleton type="button"></AppSkeleton>
    <AppSkeleton type="image"></AppSkeleton>
  </div>
</template>
